import { Snop } from "../../../../assets/svg-icons";
export const SNOP = {
  name: "S&OP",
  shortName: "S&OP",
  route: "/snop",
  icon: Snop,
  permissions: ["SNOP_VIEW"],
  extraRoutes: [
    {
      route: "/snop-detail",
      permissions: ["SNOP_VIEW"],
    },
    {
      route: "/snop/create",
      permissions: ["SNOP_VIEW"],
    },
  ],
};
